/**
 * Guocali language domains (Horizon 19-09-26).
 * The language menu lists English, Français and Español everywhere. Options marked
 * data-gl-target belong to another domain, so instead of submitting Shopify's
 * localization form we send the shopper to the same page on that domain:
 *   fr -> https://www.guocali.fr   en -> https://www.guocali.com   es -> https://www.guocali.com/es
 */
(() => {
  if (window.__guocaliLanguageDomains) return;
  window.__guocaliLanguageDomains = true;

  const TARGETS = {
    fr: 'https://www.guocali.fr',
    en: 'https://www.guocali.com',
    es: 'https://www.guocali.com/es',
  };

  // Path of the current page without the locale / market prefix (e.g. "/es", "/gb", "/ch/fr").
  const pagePath = () => {
    const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    let path = window.location.pathname;
    if (root && path.startsWith(root + '/')) path = path.slice(root.length);
    else if (root && path === root) path = '/';
    return path || '/';
  };

  const go = (code) => {
    const base = TARGETS[code];
    if (!base) return false;
    const path = pagePath();
    const params = new URLSearchParams(window.location.search);
    // When previewing an unpublished theme, keep previewing it on the other domain.
    const theme = window.Shopify && window.Shopify.theme;
    if (theme && theme.role && theme.role !== 'main' && theme.id) params.set('preview_theme_id', String(theme.id));
    const query = params.toString();
    window.location.href = base + (path === '/' ? '/' : path) + (query ? '?' + query : '') + window.location.hash;
    return true;
  };

  window.addEventListener(
    'change',
    (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || select.name !== 'language_code') return;
      const option = select.options[select.selectedIndex];
      if (!option || !option.dataset.glTarget) return;
      event.stopImmediatePropagation();
      event.preventDefault();
      // Inside the theme editor, leaving the store domain breaks the preview: stay put.
      if (window.Shopify && window.Shopify.designMode) {
        const current = [...select.options].find((o) => o.defaultSelected);
        if (current) select.value = current.value;
        return;
      }
      go(option.dataset.glTarget);
    },
    true
  );
})();
